import capitalize from "lodash/capitalize";

export const formatCategoryTitle = (
  slug: string | null | undefined,
): string => {
  if (!slug) {
    return "";
  }

  switch (slug) {
    case "cbd":
      return "CBD";
    case "science-tech":
      return "Science & tech";
    case "leafly-list":
      return "Leafly List";
    case "strains-products":
      return "Strains & products";
    default:
      return capitalize(slug).replace(/-/g, " ");
  }
};
